import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { PayrollEntry } from 'app/api/payroll.api.service';
import { takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { PayrollSelectors } from '../../selectors';
import { AppState } from 'app/reducers';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ExcelCell } from '@ag-grid-community/all-modules';
import slugify from 'slugify';
import { ExcelStyles } from 'app/main/cube/cube-detail/cube-detail-dialog.component';

@Component({
  selector: 'app-payroll-detail',
  templateUrl: './payroll-detail.component.html',
  styleUrls: ['./payroll-detail.component.scss']
})
export class PayrollDetailComponent implements OnInit, OnDestroy {
  search$: Observable<string>;
  payrolls$: Observable<PayrollEntry[]>;
  loading$: Observable<boolean>;

  private _unsubscribeAll: Subject<any>;

  public gridApi;
  public excelStyles;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      name: string;
      year: string[]
    },
    protected store: Store<AppState>
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.payrolls$ = this.store.pipe(
      takeUntil(this._unsubscribeAll),
      select(PayrollSelectors.selectPayrollByName(this.data.name))
    );
    this.excelStyles = ExcelStyles;
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  onGridReady(params): void {
    this.gridApi = params.api;
  }

  public exportExcel(): void {
    const params = this.getExportParams();
    this.gridApi.exportDataAsExcel(params);
  }

  private getExportParams(): any {
    return {
      customHeader: this.getCustomHeader(),
      fileName: this.getFileName('xlsx'),
      allColumns: true,
      sheetName: this.data.year.join('-'),
      exportMode: 'xlsx'
    };
  }

  private getCustomHeader(): ExcelCell[][] {
    const header: ExcelCell[][] = [
      [
        {
          data: {
            type: 'String',
            value: 'Detail paye ' + this.data.name + ' > ',
          },
          mergeAcross: 1,
          styleId: 'title_bold'
        },
        {
          data: {
            type: 'String',
            value: this.data.year.join('-'), // .replace('➜', '>')
          },
          mergeAcross: 7,
          styleId: 'title'
        }
      ]
    ];
    return header;
  }

  private getFileName(extension: string): string {
    return `Paye-${this.data.name}-${this.data.year.join('-')}.${extension}`;
  }
}
